import { IOProductItem } from '../../../../store/customerDetail/SecuritiesTransfer/types';
import { TableContentItemStatus } from '../../../CustomerDetail/components/SecuritiesTransfer/components/TableTransferRequests/TransferRequestsItem/components/TableContentItemStatus';
import { DynamicIOProductTableColumn } from '../DynamicIOProductTable';

export const statusColumn: DynamicIOProductTableColumn<IOProductItem> = {
  title: 'Status',
  dataKey: 'status',
  mobilePlacement: 'footer',
  render: ({ item }) => (
    <TableContentItemStatus status={item.status} statusIcon={item.statusIcon} />
  ),
};

export const fixedIncomeIncomingColumns: DynamicIOProductTableColumn<IOProductItem>[] = [
  { title: 'Qtd. de envio', dataKey: 'quantity' },
  statusColumn,
];

export const fixedIncomeOutgoingColumns: DynamicIOProductTableColumn<IOProductItem>[] = [
  { title: 'Qtd. de envio', dataKey: 'quantity' },
  { title: 'Preço unitário', dataKey: 'unitPrice' },
  { title: 'Valor a enviar', dataKey: 'amount' },
  statusColumn,
];

export const fundsIncomingColumns: DynamicIOProductTableColumn<IOProductItem>[] = [
  { title: 'Cotas a enviar', dataKey: 'quantity' },
  statusColumn,
];

export const fundsOutgoingColumns: DynamicIOProductTableColumn<IOProductItem>[] = [
  { title: 'Cotas a enviar', dataKey: 'quantity' },
  { title: 'Valor a enviar', dataKey: 'amount' },
  statusColumn,
];

export const equitiesIncomingColumns: DynamicIOProductTableColumn<IOProductItem>[] = [
  { title: 'Qtd. de envio', dataKey: 'quantity' },
  statusColumn,
];

export const equitiesOutgoingColumns: DynamicIOProductTableColumn<IOProductItem>[] = [
  { title: 'Qtd. de envio', dataKey: 'quantity' },
  { title: 'Preço médio', dataKey: 'unitPrice' },
  { title: 'Valor a enviar', dataKey: 'amount' },
  statusColumn,
];

export const dividendsColumns: DynamicIOProductTableColumn<IOProductItem>[] = [
  { title: 'Valor a enviar', dataKey: 'amount' },
  statusColumn,
];

export const treasuryColumns: DynamicIOProductTableColumn<IOProductItem>[] = [
  { title: 'Qtd. de envio', dataKey: 'quantity' },
  { title: 'Preço unitário', dataKey: 'unitPrice' },
  { title: 'Valor a enviar', dataKey: 'amount' },
  statusColumn,
];
